export default __webpack_public_path__ + "static/media/image2-7.15ed251c.png";